/**
 * @generated SignedSource<<8bd72dd4198a99fcfde2aed12dadba27>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StoredVideo_PolledBackgroundQuery$variables = {
  id?: string | null | undefined;
};
export type StoredVideo_PolledBackgroundQuery$data = {
  readonly video: {
    readonly " $fragmentSpreads": FragmentRefs<"StoredVideo_Video">;
  } | null | undefined;
};
export type StoredVideo_PolledBackgroundQuery = {
  response: StoredVideo_PolledBackgroundQuery$data;
  variables: StoredVideo_PolledBackgroundQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StoredVideo_PolledBackgroundQuery",
    "selections": [
      {
        "alias": "video",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "optionalNode",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "StoredVideo_Video"
              }
            ],
            "type": "Video",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StoredVideo_PolledBackgroundQuery",
    "selections": [
      {
        "alias": "video",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "optionalNode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "optimizedUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "posterUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enableSubtitles",
                "storageKey": null
              }
            ],
            "type": "Video",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "687f4106b6e8d129726ecb6075c045fd",
    "id": null,
    "metadata": {},
    "name": "StoredVideo_PolledBackgroundQuery",
    "operationKind": "query",
    "text": "query StoredVideo_PolledBackgroundQuery(\n  $id: ID\n) {\n  video: optionalNode(id: $id) {\n    __typename\n    ... on Video {\n      ...StoredVideo_Video\n    }\n    id\n  }\n}\n\nfragment StoredVideo_Video on Video {\n  id\n  optimizedUrl\n  posterUrl\n  status\n  ...Video_Video\n}\n\nfragment Video_Video on Video {\n  id\n  url\n  optimizedUrl\n  posterUrl\n  enableSubtitles\n}\n"
  }
};
})();

(node as any).hash = "8870ce81b8793d688157c3fb493d739b";

export default node;
